import React from "react";
import { Col, Row } from "react-bootstrap";

import { 
  FaGraduationCap,
  FaHeartbeat, 
  FaChalkboardTeacher, 
  FaWarehouse, 
  FaLaptopCode, 
  FaFireExtinguisher,
  FaIceCream,
  FaBoxOpen,
  FaCity,
  FaHandshake,
  FaMedal,
  FaBook  
} from "react-icons/fa";
import { GiDiploma, GiCapitol } from "react-icons/gi";
import "./Timeline.css"; 

function Storia() {
  // Array completo con TUTTI gli eventi della biografia in ordine cronologico
  const timelineEvents = [
    { year: "01 Giu 2020", title: "Arrivo a NeoTecno", desc: "L'inizio di una nuova vita", icon: <FaCity /> },
    { year: "7 Lug 2020", title: "Vigile del Fuoco", desc: "1 mese di servizio", icon: <FaFireExtinguisher /> },
    { year: "27 Set 2020", title: "Vodafone", desc: "8 mesi di servizio, fino a Responsabile", icon: <FaLaptopCode /> },
    { year: "16 Gen 2021", title: "Diploma", desc: "Valutazione di 100/100", icon: <GiDiploma /> },
    { year: "16 Apr 2021", title: "Ospedale", desc: "Dottore Psicologo", icon: <FaHeartbeat /> },
    { year: "02 Gen 2022", title: "Gelateria", desc: "2 mesi di servizio", icon: <FaIceCream /> },
    { year: "06 Lug 2022", title: "Magazzino", desc: "Assunzione", icon: <FaBoxOpen /> },
    { year: "29 Nov 2022", title: "Laurea in Astrofisica", desc: "Valutazione di 76/110", icon: <FaGraduationCap /> },
    { year: "16 Lug 2023", title: "Università Santa Helenie", desc: "Professore di Informatica", icon: <FaChalkboardTeacher /> },
    { year: "07 Nov 2023", title: "Magazzino", desc: "Promozione a Direttore", icon: <FaWarehouse /> },
    { year: "06 Ago 2024", title: "Ministro del Tesoro", desc: "Governo Leroux I", icon: <GiCapitol /> },
    { year: "24 Ago 2024", title: "Dimissioni Magazzino", desc: "Cessione dell'azienda a _N0N4m3", icon: <FaHandshake /> },
    { year: "27 Ago 2024", title: "Laurea in Informatica", desc: "Laurea con 110 e lode, Cultore per Titolo", icon: <FaGraduationCap /> },
    { year: "06 Ago 2024", title: "Vice Presidente di NeoTecno", desc: "Governo Beezy II", icon: <GiCapitol /> },
    { year: "01 Mag 2025", title: "Cavaliere del Lavoro", desc: "Onorificenza nell'ambito della Ricerca e Cultura", icon: <FaMedal /> },
    { year: "27 Ott 2025", title: "Congedo", desc: "Nomina a Professore Onorario", icon: <FaBook /> }
  ];

  return (
    <div className="storia-container">
      {/* --- SEZIONE TESTUALE INVARIATA --- */}
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            <span className="purple">Armando Rosaemi</span>{" "}
            nacque a {" "}<span className="purple">Napoli</span>.
            Fin dalla tenera età, mostrò una vivace{" "}
            <span className="purple">curiosità</span>:
            trascorreva interi pomeriggi immerso nei documentari, mostrando interesse per l'
            <span className="purple">informatica{" "}</span>ed l'
            <span className="purple">evoluzione tecnologica</span>.
            Dopo un'intera adolescenza a Napoli, si trasferì a <span className="purple">NeoTecno</span>, dove venne adottato da <span className="purple">Francesca Vittoria Rosaemi</span> e <span className="purple">Armando Fabrizio Rosaemi</span>, vivendo insieme a 4 fratelli: Nello G. Rosaemi, Alessandro G. Rosaemi, Vittoria F. Rosaemi e Stefano Vincenti.
            <br />
            <br />
            Il 7 luglio 2020, iniziò a lavorare come <span className="purple">Vigile del fuoco</span> per 1 mese, per poi lavorare per 8 mesi alla <span className="purple">Vodafone</span> fino a raggiungere il grado di <span className="purple">Responsabile</span>.
            Grazie al suo duro lavoro, riuscì a completare gli studi, conseguendo il{" "}
            <span className="purple">diploma{" "}</span>
            presso l'<span className="purple">Istituto Giovanni Gentile</span> il 16 gennaio 2021 con una valutazione di <span className="purple">100</span>.
            <br />
            <br />
            Dopo gli studi, a marzo 2021 si dimise dalla Vodafone e il 16 aprile iniziò a lavorare presso l'<span className="purple">Istituto Sanitario San Francesco</span>.
            Qui rimase per 9 mesi, fino al 26 novembre 2021, ottenendo tutte le specializzazioni e raggiungendo il grado di <span className="purple">Dottore Psicologo</span>.
            <br />
            <br />
            Il 2 gennaio 2022 decise di prendere una pausa dall'ambiente ospedaliero, lavorando come <span className="purple">Gelataio</span> per 2 mesi.
            Successivamente, lasciò la città per 9 mesi per dedicarsi agli studi. Ritornò il 6 luglio 2022, partecipando ai concorsi presso il <span className="purple">Magazzino</span>,
            divenendone <span className="purple">Direttore</span> il <span className="purple">7 novembre 2023</span>, portò parecchie <span className="purple">riforme</span>, rivisitò il <span className="purple">regolamento interno</span>, le mansioni dei vari ruoli, guide lavorative, e tanto altro ancora con l'aiuto dei membri della direzione. Rassegnò le dimissioni il <span className="purple">24 agosto 2024</span>, 
            dopo ben <span className="purple">2 anni, 1 mese e 18 giorni</span> di servizio in azienda. Cedette il posto al <span className="purple">Vice Direttore più anziano: _N0N4M3</span>.
            <br />
            <br />
            Il <span className="purple">29 novembre 2022</span> conseguì la <span className="purple">Laurea in Astrofisica</span> con una valutazione di 76. Il <span className="purple">27 agosto 2024</span> conseguì la <span className="purple">Laurea in Informatica</span> con una valutazione di <span className="purple">110 e lode</span>, divenendo anche <span className="purple">Cultore per Titolo</span> della facoltà.
            <br />
            <br />
            Parallelamente, il 16 luglio 2023, iniziò a la carriera accademica come Professore presso l'<span className="purple">Università Santa Helenie</span> nella facoltà di <span className="purple">Informatica</span>.
            Durante il suo percorso, raggiunse il grado di <span className="purple">Professore Ordinario</span>, fu nominato anche <span className="purple">Direttore del Dipartimento Scientifico</span> più volte volte, per molti mesi fece parte del <span className="purple">Consiglio Accademico</span>.
            Pubblicò molti testi accademici, tenne diversi seminari, contribuì agli scavi archeologici. Si è congedato il <span className="purple">27 ottobre 2025</span> congedandosi dopo <span className="purple">2 anni, 3 mesi e 11 giorni</span> di servizio,
            ricevendo il titolo di <span className="purple">Professore Onorario</span>.
          </p>
        </blockquote>
      </Row>

      {/* --- TIMELINE SECTION --- */}
      <Row className="timeline-row">
        <Col className="p-0">
          <div className="timeline-wrapper">
            <h3 className="timeline-header"><span className="purple">Timeline Eventi</span></h3>
            <div className="timeline-horizontal">
              {timelineEvents.map((item, index) => (
                <div className="timeline-item" key={index}>
                  <div className="timeline-icon-wrapper">
                    {item.icon}
                  </div>
                  <div className="timeline-content">
                    <span className="timeline-date">{item.year}</span>
                    <h5 className="timeline-title">{item.title}</h5>
                    <p className="timeline-desc">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Storia;